import * as types from "../../constants/actionTypes";
import moment from 'moment';

const initState = {
    isLoading: false,
    listReservasiPasien: [],
    formPembayaranPasien: {
        totalBiaya: "",
        totalKembalian: "",
        totalDibayar: "",
        dataReservasi: {
            f_no_identitas: "",
            f_nama_pasien: "",
            f_nama_poliklinik: "",
            f_nama_dokter: "",
            f_tgl_reservasi: "",
        },
        listLayanan: [],
        listObat: [],
    },

    
};

export default function (state = initState, action) {
    switch (action.type) {
        case types.MODULE_KASIR_SET_LOADER: {
            return{
                ...state,
                isLoading: action.value
            }
        }
        case types.MODULE_KASIR_LISTDATA_RESERVASI_GET_SUCCESS: {
            return{
                ...state,
                listReservasiPasien: action.value
            }
        }
        case types.MODULE_KASIR_DETAIL_RESERVASI_GET_SUCCESS: {
            return{
                ...state,
                formPembayaranPasien: {...initState.formPembayaranPasien, ...action.value}
            }
        }
        case types.MODULE_KASIR_HANDLE_STATE_FORM_PEMBAYARAN: {
            return {
                ...state,
                formPembayaranPasien: {
                    ...state.formPembayaranPasien,
                    [action.property]: action.value,
                }
            }
        }
        default:
            return {
                ...state
            }
    }
}  